import { ApolloError } from '@apollo/client';

export type ApolloErrorObject =
  | {
      code: 'RECORD_NOT_FOUND' | string;
      parameters?: Record<string, number | string>;
    }
  | {
      message: string;
    };

export const parseApolloError = (error: ApolloError): ApolloErrorObject => {
  const extension = error.graphQLErrors[0].extensions;

  if (extension?.code && typeof extension.code === 'string') {
    return {
      message: error.message,
      code: extension.code,
      parameters: extension.parameters as Record<string, number | string> | undefined,
    };
  } else {
    return {
      message: error.message,
    };
  }
};
